import React, { useCallback, useEffect, useState } from 'react';
import { Auth, graphqlOperation } from 'aws-amplify';
import { Connect } from 'aws-amplify-react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { Layout, Loading, Messenger, UserNavbar } from '../../../components';
import * as queries from '../../../graphql/queries';
import * as subscriptions from '../../../graphql/subscriptions';
import * as mutations from '../../../graphql/mutations';
import * as UserActions from '../../../core/users/action';
import * as ChatActions from '../../../core/chat/action';

export default function Inbox() {
  const {
    users: { usersList },
    chat: { conversationList, activeConversation },
  } = useSelector((store) => store);

  const dispatch = useDispatch();
  const { id: userIdParam } = useParams();
  const [username, setUsername] = useState();

  const getCurrentUser = useCallback(async () => {
    const user = await Auth.currentAuthenticatedUser();
    setUsername(user.username);
  }, []);

  const onSubscriptionMsg = (prev, data) => ({
    getMessages: [...prev.getMessages, data.addMessage],
  });

  const addContact = (userSelected) => {
    if (userSelected) dispatch(ChatActions.onAddUserToConversationList(userSelected));
  };

  const onChangeConversation = (user) => {
    if (user) dispatch(ChatActions.onChangeConversation(user, user.id));
  };

  useEffect(() => {
    if (userIdParam && usersList.length > 0) {
      const userFound = usersList.find((us) => us.id === Number(userIdParam));
      if (!userFound) return;
      dispatch(ChatActions.onAddUserToConversationList(userFound));
      dispatch(ChatActions.onChangeConversation(userFound, Number(userIdParam)));
    }
  }, [dispatch, userIdParam, usersList]);

  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);

  useEffect(() => {
    dispatch(UserActions.getUsers());
  }, [dispatch]);

  return (
    <Layout>
      <UserNavbar />
      {username && (
        <Connect
          query={graphqlOperation(queries.getMessages)}
          mutation={graphqlOperation(mutations.createMessage)}
          subscription={graphqlOperation(subscriptions.addMessage)}
          onSubscriptionMsg={onSubscriptionMsg}>
          {({ mutation, data: { getMessages }, loading, error }) => {
            if (error) return <h3>Error</h3>;
            if (loading || !getMessages) return <Loading />;
            return (
              <Messenger
                username={username}
                contacts={usersList}
                messages={getMessages}
                conversations={conversationList}
                activeUserConversation={activeConversation}
                onChangeConversation={onChangeConversation}
                addContact={addContact}
                onCreate={mutation}
              />
            );
          }}
        </Connect>
      )}
    </Layout>
  );
}
